export default "__VITE_ASSET__CYESo_7Q__"